import React, { Component } from 'react';
import Comment from 'react-icons/lib/md/comment';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import './professionalReviews.less';
import { Card } from 'react/card/Card';
import CardTitle from 'react/card/CardTitle';
import { OverviewFooter } from 'react/card/OverviewFooter';
import SingleButtonFooter from 'react/card/SingleButtonFooter';
import ProfessionalReview from 'models/ProfessionalReview';
import ResultsModal from 'react/views/generic/ResultsModal';
import TrackedLink from 'react/views/generic/TrackedLink';
import ProfessionalReviewsEventTypes from 'data/types/ProfessionalReviewsEventTypes';
import ContentTitle from 'react/views/generic/ContentTitle';
import ModalTextWithHeader from 'react/views/generic/ModalTextWithHeader';
import Icon from 'react/views/generic/Icon';

class ProfessionalReviewsView extends Component {
	constructor() {
		super();

		this.state = {
			isModalOpen: false,
			displayFullList: false,
			numberOfItemsToRender: 4
		};

		this.toggleFullList = this.toggleFullList.bind(this);
		this.onModalOpen = this.onModalOpen.bind(this);
        this.onModalClose = this.onModalClose.bind(this);
	}

	toggleFullList() {
		this.setState((prevState) => ({
			displayFullList: !prevState.displayFullList
		}));
	}

    /**
     * open the modal and list out the reviews separated by horizontal rules.
     * @param {object} reviewGroup
     */
    onModalOpen(reviewGroup) {
		this.setState({
                isModalOpen: true,
                modalContent: reviewGroup});
    }

    onModalClose() {
		this.setState({isModalOpen: false});
    }

    renderReviewsList(reviews) {
		let listItems = reviews && reviews.map((reviewGroup, index) => {
			return (
				<TrackedLink featureType={ProfessionalReviewsEventTypes.PROFESSIONALREVIEWS_NAME_CLICKED} destId={reviewGroup.publicationCode} srcId={this.props.loggingId} key={index}>
                    <li key={index} className="clickable review-source" onClick={() => this.onModalOpen(reviewGroup)}>
                        {reviewGroup.publication} ({reviewGroup.reviews.length})
                    </li>
                </TrackedLink>
			);
		});

		if (!this.state.displayFullList) {
			listItems = listItems.slice(0, this.state.numberOfItemsToRender);
		}

        return (
            <ul id='reviews-list' className={classNames('reviews-list', { 'scrollable-list': this.state.displayFullList})}>
                { listItems }
            </ul>
        );
	}

	renderFooter(reviewSources) {
		if(reviewSources.length > this.state.numberOfItemsToRender){
			let text = this.state.displayFullList ? 'See less' : 'See more';
			return <SingleButtonFooter buttonText={text} onClick={this.toggleFullList} />
		}
		else{
			return <OverviewFooter />
		}
	}

    renderProfessionalReviews(reviewGroup) {
        return reviewGroup.reviews.map((r) => (
                <ModalTextWithHeader key={r.id} headerText={r.issue} contentText={r.review}/>
        ));
    }

    render() {
        return (
            <Card>
                <CardTitle title="Professional Reviews"/>
                <div className={classNames("reviews-card-content", { "reviews-card-content-full": this.state.displayFullList })}>
                    {!this.state.displayFullList && <Icon icon={Comment} color={"rgba(47,85,151,1)"} />}
                    {!this.state.displayFullList && <ContentTitle>
                        What do reviewers say?
					</ContentTitle>}
                    {this.renderReviewsList(this.props.cardModel)}
				</div>
                <ResultsModal
                    modalTitle={this.state.modalContent && this.state.modalContent.publication}
                    isLoading={false}
                    isOpen={this.state.isModalOpen}
                    close={this.onModalClose}
                    isScrollable>
                    <div className="reviews-modal-content">
                        {this.state.modalContent && this.renderProfessionalReviews(this.state.modalContent)}
                    </div>
                </ResultsModal>
				{this.renderFooter(this.props.cardModel)}
            </Card>
        );
    }
}


ProfessionalReviewsView.propTypes = {
    cardModel: PropTypes.arrayOf(PropTypes.instanceOf(ProfessionalReview)).isRequired
}

export default ProfessionalReviewsView;



// WEBPACK FOOTER //
// ./src/react/views/professionalReviews/ProfessionalReviewsView.jsx